import { useEffect, useState } from 'react';

import { Partner, PartnerCategory } from 'types';
import { useSelector } from 'react-redux';
import { State } from 'redux/initialState';

type UseGetPartnerCategoriesProps = {
  partner: Partner | null;
};

export const useGetPartnerCategories = ({
  partner,
}: UseGetPartnerCategoriesProps) => {
  const partnerCategories = useSelector(
    (state: State) => state.partnerCategories
  );

  const [categories, setCategories] = useState<PartnerCategory[]>([]);

  useEffect(() => {
    if (partnerCategories?.length && partner?.categories) {
      const categories = partnerCategories.filter((category) =>
        partner.categories?.includes(category._id)
      );

      setCategories(categories as PartnerCategory[]);
    }
  }, [partner, partnerCategories]);

  return { data: { categories } };
};
